import IconEnvelopeSolid from '@/assets/icons/font_awesome/envelope-solid.svg?react';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__input } from '../../../components/ui/UI_PRIMITIVE__input';
import { ENUM__i18n_namespace } from '../../../services/i18n/ENUM__i18n_namespace';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

export const A_INPUT__email = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);
  const { page_auth_is_loading } = use_slice_ui(['page_auth_is_loading']);

  return (
    <UI_PRIMITIVE__input
      type="email"
      placeholder={t(i18n_page_auth.auth_component.input.email_placeholder)}
      disabled={page_auth_is_loading}
      iconStart={
        <UI_PRIMITIVE__icon_animated
          className="!size-4 pointer-events-none"
          Icon={IconEnvelopeSolid}
          renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        />
      }
      ref={ref}
      {...props}
    />
  );
});

A_INPUT__email.displayName = 'AEmailInput';
